// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3Q1IP","actionsCol":"EnrolledClinics_actionsCol__22mtO"};